import { Modal } from "./types";
import { resetBodyScroll } from "src/utils/scrollUtil";

export const ModalActions = {
    Open: (component, options = {}) => {
        resetBodyScroll(false);
        return {
            type: Modal.OPEN,
            component,
            options,
        };
    },
    Close: (options = {}) => {
        resetBodyScroll(true);
        return {
            type: Modal.CLOSE,
            options,
        };
    },

    CloseAll: (options = {}) => {
        resetBodyScroll(true);
        return {
            type: Modal.CLOSE_ALL,
            options,
        };
    },

    Update: (options) => {
        return {
            type: Modal.UPDATE,
            options,
        };
    },
};
